export default "__VITE_ASSET__DxQ1ZqQl__"